import { createContext, useState, useCallback, type ReactNode } from "react";

export interface DetailModalContextValue {
  visible: boolean;
  type: DetailType;
  id: number | null;
  showDetail: (type: DetailType, id: number) => void;
  closeDetail: () => void;
}

export type DetailType =
  | "issue"
  | "customer"
  | "product"
  | "project"
  | "feature"
  | "activation"
  | "installation"
  | "";

export const DetailModalContext = createContext<
  DetailModalContextValue | undefined
>(undefined);

export function DetailModalProvider({ children }: { children: ReactNode }) {
  const [visible, setVisible] = useState(false);
  const [type, setType] = useState<DetailType>("");
  const [id, setId] = useState<number | null>(null);

  const showDetail = useCallback((t: DetailType, resourceid: number) => {
    if (!t || !resourceid) {
      console.warn("showDetail: type and id are required");
      return;
    }
    setType(t);
    setId(resourceid);
    setVisible(true);
  }, []);

  const closeDetail = useCallback(() => {
    setVisible(false);
    setTimeout(() => {
      setType("");
      setId(null);
    }, 300);
  }, []);

  return (
    <DetailModalContext.Provider
      value={{ visible, type, id, showDetail, closeDetail }}
    >
      {children}
    </DetailModalContext.Provider>
  );
}
